import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenProviderService } from '@api/authentication';
import { LocalCredentialsModel } from '@database/central';
import { UserService } from '@domain/registration';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingKeys, ToastDuration, ToastService } from '@shared';
import { AccountStateService } from '../../services/account-state.service';
import { AccountBaseComponent } from '../base';
import {
	notAllowedCharactersValidation,
	startWithCharactersValidation
} from '../../../../domain/dynamic-form/validations/validator-functions/custom-form-validations';

@Component({
	selector: 'app-registration-username',
	templateUrl: 'account-username.component.html',
	styleUrls: ['../../account.scss']
})
export class AccountUsernameComponent extends AccountBaseComponent implements OnInit {
	public formValidationMessages = [];

	public constructor(
		private accountStateService: AccountStateService,
		private toastService: ToastService,
		private translate: TranslateService,
		private userService: UserService,
		private tokenProviderService: TokenProviderService,
		public navController: NavController,
		public router: Router
	) {
		super(navController, router);
	}

	public get helperText(): string {
		const content = this.isRegistration() ? 'registration.content.username' : 'reset.content.username';
		return this.translate.instant(content);
	}

	public ngOnInit(): void {
		this.fieldFormControl = new FormControl('', [
			Validators.required,
			Validators.maxLength(30),
			startWithCharactersValidation,
			notAllowedCharactersValidation
		]);

		this.registrationForm = new FormGroup({
			fieldFormControl: this.fieldFormControl
		});

		this.formValidationMessages = [
			{
				type: 'required',
				message: this.translate.instant('registration.form.validations.username.required')
			},
			{ type: 'maxlength', message: this.translate.instant('registration.form.validations.username.maxlength') },
			{
				type: 'startWithCharacters',
				message: this.translate.instant('registration.form.validations.username.startWithCharacters')
			},
			{
				type: 'notAllowedCharacters',
				message: this.translate.instant('registration.form.validations.username.notAllowedCharacters')
			}
		];

		// If going in the reset/registration flow, you should have no token still left in the local storage.
		// this.tokenProviderService.save('');
	}

	public async onSubmit(formValues: { fieldFormControl: string }): Promise<void> {
		if (!this.isFormValid()) {
			return;
		}

		const userDetails: LocalCredentialsModel | null = await this.userService.getUserDetails(
			formValues.fieldFormControl.trim()
		);

		if (this.isRegistration() && userDetails) {
			await this.toastService.presentError(
				this.translate.instant('registration.errorMessages.alreadyRegistered'),
				ToastDuration.Slow
			);
			return;
		}

		this.accountStateService.setUsername(formValues.fieldFormControl.trim());
		const route = this.isRegistration() ? 'registration' : 'reset';

		await this.navController.navigateForward(`${route}/${AppRoutingKeys.urlPathRegistrationFusionPassword}`);
	}
}
